import axios from "axios";
import { NavigateFunction } from "react-router-dom";

const checkTodayKey = (navigate: NavigateFunction) => {
  const getLocalStorageKey = () => {
    const key = localStorage.getItem("today-key");
    if (key) {
      return key || null;
    }
  };
  const today = getLocalStorageKey();
  const url = "https://8slqmvh323.execute-api.ap-northeast-1.amazonaws.com/poc";

  axios
    .post(url, { verify_string: today })
    .then((response) => {
      if (response.data) {
        if (JSON.parse(response.data.body).authenticated) {
          return;
        } else {
          navigate("/nottoday");
        }
        return;
      } else {
        navigate("/");
      }
    })
    .catch((error) => {
      console.error("Error checking today key:", error);
    });
};
export default checkTodayKey;
